"use client";

import React, { useEffect, useState } from "react";
import { Carousel, CarouselContent, CarouselItem, type CarouselApi } from "@/components/ui/carousel";
const logos = [{
  name: "Marriott International",
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1676583/img/marriott_logo_gold.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1676583/img/marriott_logo_gold.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1676583/img/marriott_logo_gold.png-wvc-sizes"
}, {
  name: "Sheraton Hotels",
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1676583/img/sheraton_logo_gold.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1676583/img/sheraton_logo_gold.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1676583/img/sheraton_logo_gold.png-wvc-sizes"
}, {
  name: "Le Méridien",
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1676583/img/le_meridien_logo_gold.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1676583/img/le_meridien_logo_gold.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1676583/img/le_meridien_logo_gold.png-wvc-sizes"
}, {
  name: "Cybersecurity Gold",
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1676583/img/cyber_partner_logo.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1676583/img/cyber_partner_logo.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1676583/img/cyber_partner_logo.png-wvc-sizes"
}, {
  name: "Infrastructure Partner",
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1676583/img/infra_partner_logo.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1676583/img/infra_partner_logo.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1676583/img/infra_partner_logo.png-wvc-sizes"
}, {
  name: "Virtualization Expert",
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1676583/img/vm_partner_logo.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1676583/img/vm_partner_logo.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1676583/img/vm_partner_logo.png-wvc-sizes"
}];
export default function DeveloperEcosystem() {
  const [api, setApi] = useState<CarouselApi>();
  useEffect(() => {
    if (!api) return;
    const interval = setInterval(() => {
      api.scrollNext();
    }, 3000);
    return () => clearInterval(interval);
  }, [api]);
  return <section data-section-id="259113" id="global-hospitality-excellence" className="bg-background text-foreground py-16 md:py-24 border-y border-secondary/30 overflow-hidden relative">
      {}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[80%] h-[100px] bg-secondary/5 blur-[100px] pointer-events-none rounded-lg" />

      <div className="container mx-auto px-4 relative z-10">
        <div className="text-center mb-12">
          <h2 className="text-sm font-mono text-secondary tracking-widest uppercase">
            Hospitality Specialists
          </h2>
        </div>

        <div className="w-full max-w-5xl mx-auto">
          <Carousel opts={{
          loop: true,
          align: "start",
          dragFree: true
        }} setApi={setApi} className="w-full">
            <CarouselContent className="-ml-4 md:-ml-8 flex items-center">
              {logos.map((logo, i) => <CarouselItem key={i} data-index={i} className="pl-4 md:pl-8 basis-1/3 md:basis-1/4 lg:basis-1/6 flex justify-center">
                  <div className="relative group flex items-center justify-center h-24 w-full cursor-pointer border border-border/20 rounded-md bg-card/30 backdrop-blur-sm transition-colors duration-300 hover:border-secondary/50">
                    <img src={logo.src} data-wvc-srcset={logo.srcset} data-wvc-sizes={logo.sizes} alt={`${logo.name} logo`} className="max-h-12 max-w-[100px] object-contain opacity-40 grayscale transition-all duration-500 ease-out group-hover:opacity-100 group-hover:grayscale-0 group-hover:scale-110 group-hover:drop-shadow-[0_0_15px_var(--color-secondary)]" loading="lazy" />
                  </div>
                </CarouselItem>)}
            </CarouselContent>
          </Carousel>
        </div>

        <div className="mt-12 flex justify-end">
          <a href="/LegacyPage" className="text-xs font-mono text-muted-foreground hover:text-secondary transition-colors flex items-center gap-2 group">
            VIEW CASE STUDIES 
            <span className="transition-transform duration-300 group-hover:translate-x-1">→</span>
          </a>
        </div>
      </div>
    </section>;
}